// utils
import get from "Utils/get";

/**
 * The purpose of this function is to sort data on the front end
 * based on user selections
 * @param {array} functions
 * @param {string} sortName
 * @param {string} sortDirection
 */
export default (functions, sortName, sortDirection) => {
	const arrayToSort = JSON.parse(JSON.stringify(functions));

	arrayToSort.sort((a, b) => {
		const aValue = get([sortName], a);
		const bValue = get([sortName], b);

		const normalizedValueA = typeof aValue === "string" ? aValue.toLowerCase() : aValue;
		const normalizedValueB = typeof aValue === "string" ? bValue.toLowerCase() : bValue;

		if (sortDirection === "desc") {
			return normalizedValueA > normalizedValueB ? 1 : -1;
		}
		return normalizedValueA > normalizedValueB ? -1 : 1;
	});

	return arrayToSort;
};
